import { CourseEnrolmentState, StudentState } from '../../types/common';

export const ACTIVE_STUDENT_STATES = [
  StudentState.Active,
  StudentState.OnTrial,
  StudentState.PendingAttendance,
];

export const INACTIVE_STUDENT_STATES = [
  StudentState.Enrolled,
  StudentState.Lead,
  StudentState.Graduated,
  StudentState.Archived,
];

export const ACTIVE_COURSE_STATES = [
  CourseEnrolmentState.Active,
  CourseEnrolmentState.OnTrial,
];

export const INACTIVE_COURSE_STATES = [
  CourseEnrolmentState.Unenrolled,
];
